import { device } from "common/src/styles/Reset";
import styled from "styled-components";

export const ConversationContainer = styled.div`
  position: relative;
  @media ${device.tablet} {
    max-width: 500px;
    margin: 0 auto;
  }
`;
